import * as yup from 'yup';

export const useAddScheduleTerminalsValidation = () => {
  const schema = yup.object().shape({
    idTkds: yup.array().min(1),
  });

  return { schema };
};
